// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"table_scrollable__9Hqtw","table":"table_table__6yLaw","tableWrapper":"table_tableWrapper__aTPT2"};